<template>
  <div style="position relative;">
    <div class="header">
      <v-btn icon small text class="handle2">
        <v-icon small>mdi-drag</v-icon>
      </v-btn>
      <v-menu :close-on-content-click="false" :nudge-width="200" offset-x>
        <template v-slot:activator="{ on }">
          <v-btn icon small text v-on="on" class="dots-button">
            <v-icon small>mdi-cog</v-icon>
          </v-btn>
        </template>
        <slot name="menu" />
      </v-menu>
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  };
</script>

<style scoped>
.header {
  height: 30px;
}
.handle {
  cursor: ns-resize;
  margin-top: 2px;
  position: absolute;
  top: 0;
  left: 0;
}

.dots-button {
  margin-top: 2px;
  position: absolute;
  top: 0;
  right: 0;
}
</style>